export const GET_STRAINS_REQUEST = 'GET_STRAINS_REQUEST';
export const GET_STRAINS_SUCCESS = 'GET_STRAINS_SUCCESS';
export const GET_STRAINS_FAILURE = 'GET_STRAINS_FAILURE';

export const GET_HARVEST_SCHEDULE_REQUEST = 'GET_HARVEST_SCHEDULE_REQUEST';
export const GET_HARVEST_SCHEDULE_SUCCESS = 'GET_HARVEST_SCHEDULE_SUCCESS';
export const GET_HARVEST_SCHEDULE_FAILURE = 'GET_HARVEST_SCHEDULE_FAILURE';

export const GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_REQUEST = 'GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_REQUEST';
export const GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_SUCCESS = 'GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_SUCCESS';
export const GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_FAILURE = 'GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_FAILURE';

export const GET_MONTHLY_TOTAL_YIELD_REQUEST = 'GET_MONTHLY_TOTAL_YIELD_REQUEST';
export const GET_MONTHLY_TOTAL_YIELD_SUCCESS = 'GET_MONTHLY_TOTAL_YIELD_SUCCESS';
export const GET_MONTHLY_TOTAL_YIELD_FAILURE = 'GET_MONTHLY_TOTAL_YIELD_FAILURE';

export const GET_IN_FLIGHT_REQUEST = 'GET_IN_FLIGHT_REQUEST';
export const GET_IN_FLIGHT_SUCCESS = 'GET_IN_FLIGHT_SUCCESS';
export const GET_IN_FLIGHT_FAILURE = 'GET_IN_FLIGHT_FAILURE';